import { hueFor, initials } from './avatar';
import type { ContactCardData } from './types';

/**
 * ONE card holding ALL matched contacts, laid out as a 2-column grid. Each cell
 * (avatar + name + email/title) is clickable → onOpenContact(id), which opens
 * the existing ContactCardPopover. Mirrors EmailResultCard avatar styling.
 */

export function ContactsGridCard({
  data,
  onOpenContact,
}: {
  data: ContactCardData;
  onOpenContact: (id: string) => void;
}) {
  const contacts = data.contacts ?? [];
  if (!contacts.length) return null;

  return (
    <div className="rc-card rc-contacts">
      <div className="rc-meta">
        <span className="rc-meta-kind">👤 CONTACTS</span>
        <span className="rc-meta-sep">·</span>
        <span className="rc-meta-match">{contacts.length}</span>
      </div>

      <div className="rc-contacts-grid">
        {contacts.map((c) => {
          const sub = c.title || c.company || c.email || '';
          return (
            <button
              key={c.id}
              type="button"
              className="rc-contact-cell"
              onClick={() => onOpenContact(c.id)}
            >
              {c.photoUrl ? (
                <img className="rc-av" src={c.photoUrl} alt="" />
              ) : (
                <div
                  className="rc-av rc-av-initials"
                  style={{ background: hueFor(c.email || c.name || c.id) }}
                >
                  {initials(c.name, c.email || '')}
                </div>
              )}
              <div className="rc-contact-text">
                <span className="rc-contact-name">{c.name || c.email || 'Unknown'}</span>
                {sub && <span className="rc-contact-sub">{sub}</span>}
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
}
